import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ResultView from '../views/ResultView.vue'
import Auth from '../views/Auth.vue'
import Exam from '../views/Exam.vue'


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  
  {
    path: '/end',
    name: 'end',
    component: ResultView
  },
  {
    path: '/exam/:shikenId/:id',
    name: 'Exam',
    component: Exam
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //      return savedPosition
  //   } else {
  //      return { x: 0, y: 0 }
  //   }
  // }
})

export default router
